// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"c28f67bc","217":"6edb4c49","488":"23c5adc8","904":"fc9ae135"}[chunkId] + ".chunk.js";
};